export const endpoints = {
  get: '/periodicEventControl/:centralId',
  activate: '/periodicEventControl/:id/activate',
  deactivate: '/periodicEventControl/:id/deactivate',
}
